<app-visualization
    #visualizationComponent
    [widgetId]="widgetId"
    [vizConfig]="visualizationModel"
    [vizInfo]="vizInfo"
    [useNewLegend]="useNewLegend"
    [fieldMetadata]="fieldMetadata"
>
</app-visualization>
